import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es7.object.values";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/typeof";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export * from "./date-helpers";
export * from "./time-helpers";
/**
 * Returns the indexed by one field collection
 * @param {any[]} arr - array to be converted into the indexed collection
 * @param {string|symbol} fieldName - filed name for indexing
 * @param {object} mixin - object to be mixed to every object in collection
 * @returns {any}
 */

export function getIndexedCollection(arr) {
  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  var mixin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!arr || !arr.length) {
    return {};
  }

  return arr.reduce(function (acc, el) {
    acc[el[fieldName]] = _objectSpread(_objectSpread({}, el), mixin);
    return acc;
  }, {});
}
/**
 * Returns object contains only truthy fields
 * @param {object} [obj] - any object
 * @returns {object}
 */

export function formTruthyFields() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!obj || _typeof(obj) !== 'object') {
    return {};
  }

  return Object.keys(obj).filter(function (el) {
    return obj[el];
  }).reduce(function (acc, el) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, el, obj[el]));
  }, {});
}
/**
 * Returns the array containing only items with unique keys
 * @param {any[]} arr - array to filter
 * @param {string} fieldName - unique key
 * @returns {any[]}
 */

export function filterByUniqueField(arr) {
  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  var collection = getIndexedCollection(arr, fieldName);
  return Object.values(collection);
}
/**
 * Returns an array containing values of entered field name
 * @param {any[]} arr - array to search for
 * @param {string|symbol} fieldName - field name to lens
 */

export function lens(arr, fieldName) {
  if (!arr || !Array.isArray(arr)) {
    return [];
  }

  return arr.map(function (el) {
    return el[fieldName];
  });
}
/**
 * Waits entered time
 * @param {number} ms - quantity of milliseconds to wait
 */

export function timeout(_x) {
  return _timeout.apply(this, arguments);
}
/**
 * Splits the array into the specified parts
 * @param {any[]} arr
 * @param {number} partSize
 */

function _timeout() {
  _timeout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ms) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve) {
              setTimeout(resolve, ms);
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _timeout.apply(this, arguments);
}

export function splitArray(arr, partSize) {
  var outputSize = Math.ceil(arr.length / partSize);
  var output = [];
  var currentIndex = 0;

  for (var i = 0; i < outputSize; i++) {
    output[i] = arr.slice(currentIndex, currentIndex + partSize).filter(function (el) {
      return el !== undefined;
    });
    currentIndex += partSize;
  }

  return output;
}
/**
 * Returns number with entered precision
 * @param {number} number number to be rounded
 * @param {number} digits number of digits
 * @example roundAndSuppressZeros(1.1234, 3) // 1.123
 * roundAndSuppressZeros(1.1234) // 1.12
 * roundAndSuppressZeros(15, 3) // 15
 */

export function roundAndSuppressZeros(number) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var correction = Math.pow(10, digits);
  return Math.round(number * correction) / correction;
}
export function validateIPaddress(ipaddress) {
  var ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  var ipv6Pattern = /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/;

  if (ipv4Pattern.test(ipaddress)) {
    return true;
  } else if (ipv6Pattern.test(ipaddress)) {
    return true;
  }

  return false;
}